import {FC} from 'react';
import {Popup} from 'semantic-ui-react';

import Description from '../Description';
import {BaseActionButton} from './BaseActionButton';

class GenerateSummary extends BaseActionButton {
  icon = 'file alternate';
  tooltip = 'Generate Summary';

  render: FC = () => {
    return (
      <Popup
        {...this.popupCommonProps()}
      >
        <Description />
      </Popup>
    );
  };
}

export {GenerateSummary};
